<template>
  <div class="home-layout">
    <div class="header">
      <span class="product">Navigo</span>
      <span class="voyager">by <img src="../assets/header.png"/></span>
    </div>
    <SearchBar ref="voyagerSearchBar"
      @search="updateSearch"
      :keywordSuggestions="keywordSuggestions"
      :placeSuggestions="placeSuggestions" 
      class="search-bar" />
  </div>
  <div>
    <span></span>
  </div>
</template>

<script setup lang="ts">
import { routerPush } from '@/router';
import { useQueryStore } from '@/store/query';
import { SearchBar } from 'VoyagerComponents';
import { onMounted, ref, Ref, watchEffect } from 'vue';

const voyagerSearchBar: Ref<typeof SearchBar | null> = ref(null),
  { setQuery, setPlace, setIntersects, setExpansion } = useQueryStore(),
  updateSearch = (searchbarState) => {
    const { keyword, place, intersects, expansion } = searchbarState;
    setQuery(keyword);
    setPlace(place);
    setIntersects(intersects);
    setExpansion(expansion);
    routerPush('search')
  };
const keywordList = ['water', 'roads', 'canals', 'lakes'];
const placeList = ['Australia', 'Canada', 'Norway'];
const keywordSuggestions: Ref<string[]> = ref([]);
const placeSuggestions: Ref<string[]> = ref([]);

onMounted(() => {
   watchEffect(() => {
    if(voyagerSearchBar.value?.keyword === ''){
        keywordSuggestions.value = [];
      } else {
        keywordSuggestions.value = keywordList.filter(v => 
          v.toLowerCase().includes(voyagerSearchBar.value?.keyword?.toLowerCase()));
      };

      if(voyagerSearchBar.value?.place === ''){
        placeSuggestions.value = [];
      } else {
        placeSuggestions.value = placeList.filter(v => 
          v.toLowerCase().includes(voyagerSearchBar.value?.place?.toLowerCase()));
      }
   })
})

</script>

<style scoped lang="scss">

.home-layout {
  display: flex;
  align-items: center;
  flex-direction: column;
  height: 100%;
}
.header {
  color: var(--color-text-primary);
  font-family: var(--font-family);
  display: flex;
  flex-direction: column;
  position: relative;
  top: 15%;
  .product {
    font-size: 4rem;
  }
  .voyager {
    font-size: 1rem;
    display: flex;
    align-self: center;
    align-items: center;
    font-weight: bold;
    img {
      height: 2rem;
      margin-left: 3px;
    }
  }
}
.search-bar {
  width: clamp(300px, 50vw, 750px); 
  position: relative;
  top: 25%;
}
</style>